
class logoSlider extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.slideshow = this.querySelector(".logo__selector");
    if (!this.slideshow) return;
    const resizeObserver = new ResizeObserver((entries) => this.init());
    resizeObserver.observe(this.slideshow);
  }
  init() {

    const slider = new Swiper(this.slideshow, {
      effect: "slide",
      slidesPerView: parseInt(this.slideshow.dataset.slidesmobile),
      grabCursor: true,
      freeMode: false,
      loop: true,
      speed: 800,
      autoplay: {
        enabled: true,
        delay: 1500,
        disableOnInteraction: false,
      },
      breakpoints: {
        359: {
          slidesPerView: parseInt(this.slideshow.dataset.slidesmobile),
        },
        768: {
          slidesPerView: parseInt(this.slideshow.dataset.slidesdesktop),
        }
      },
    });

    return slider;
  }
}
customElements.define("logo-element", logoSlider);




class NavigationSlider extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {

    this.slideshow__for = this.querySelector(".slideshow__for");
    this.slideshow__nav = this.querySelector(".slideshow__nav");

    if (!this.slideshow__nav) return;
    const resizeObserver = new ResizeObserver((entries) => this.init());
    resizeObserver.observe(this.slideshow__nav);
  }

  init(){

 
    let pagination = this.querySelector(".swiper-pagination");


    var slideshow__for = new Swiper (this.slideshow__for, {
      slidesPerView: 1,
      centeredSlides: true,
      grabCursor: true,
      loop: false
    });
    
    
    var slideshow__nav = new Swiper (this.slideshow__nav, {
      slidesPerView: 'auto',
      spaceBetween: 10,
      centeredSlides: true,
      grabCursor: true,
      slideToClickedSlide: true,
      loop: false,
      autoplay: {
        enabled: false,
        disableOnInteraction: false,
      },
      pagination: {
        el: pagination,
        clickable: true,
      }
    });
    
    slideshow__for.controller.control = slideshow__nav;
    slideshow__nav.controller.control = slideshow__for;
    return true; 
  }

}
customElements.define("navslider-component", NavigationSlider);



$('.accordion__head').on('click', function() {
  // $('.accordion-content').slideUp();
  // $('.accordion-content').removeClass('active');
  $(this).siblings('.accordion-content').slideToggle();
  $(this).toggleClass('active');
}); 




$(document).ready(function() {

  $('.twosome_applicable').change(function() {
      if($(this).is(":checked")) {
      // $(this).parents('.aplicable-content').find('.field__input').attr('required', true);
      // $(this).parents('.aplicable-content').find('.field__label span').attr('aria-hidden', true);
      $(this).parents('.aplicable-content').find('.piaring-toggole-content').slideDown();
     
      $(this).parents('.aplicable-content').find('.piaring-toggole-content').find('.field__input').attr('required', true);
      $(this).parents('.aplicable-content').find('.piaring-toggole-content').find('.field__label span').attr('aria-hidden', true);


      }else{
        // $(this).parents('.aplicable-content').find('.field__input').attr('required', false);
        // $(this).parents('.aplicable-content').find('.field__label span').attr('aria-hidden', false);
   
        $(this).parents('.aplicable-content').find('.piaring-toggole-content').slideUp();

        $(this).parents('.aplicable-content').find('.piaring-toggole-content').find('.field__input').attr('required', false);
        $(this).parents('.aplicable-content').find('.piaring-toggole-content').find('.field__label span').attr('aria-hidden', false);
      }
     
  });

  $('.foursome_applicable').change(function() {
      if($(this).is(":checked")) {
      $(this).parents('.aplicable-content').find('.field__input').attr('required', true);
      $(this).parents('.aplicable-content').find('.field__label span').attr('aria-hidden', true);
      }else{
        $(this).parents('.aplicable-content').find('.field__input').attr('required', false);
        $(this).parents('.aplicable-content').find('.field__label span').attr('aria-hidden', false);
      }
     
  });



  var selected_value = $('.product-form__input input[name="Choose Type"]:checked').val();
  // console.log("Tress", selected_value);


  if(selected_value == "FOURSOME"){

    $('.accordion__foursome').addClass('active');
    $('.accordion__foursome').find('.accordion__head').addClass('active');
    $('.accordion__foursome').find('.accordion-content').slideDown();



   $('.accordion__twosome').removeClass('active');
   $('.accordion__twosome').find('.accordion__head').removeClass('active');
   $('.accordion__twosome').find('.accordion-content').slideUp();

   $('.accordion__twosome').find('.aplicable-content').find('.field__input').attr('required', false);
   $('.accordion__twosome').find('.aplicable-content').find('.field__label span').attr('aria-hidden', false);


   $('.twosome-text').hide();
   $('.foursome-text').show();

  }
   if(selected_value == "TWOSOME"){

    $('.accordion__twosome').addClass('active');
    $('.accordion__twosome').find('.accordion__head').addClass('active');
    $('.accordion__twosome').find('.accordion-content').slideDown();


   $('.accordion__foursome').removeClass('active');
   $('.accordion__foursome').find('.accordion__head').removeClass('active');
   $('.accordion__foursome').find('.accordion-content').slideUp();

   $('.accordion__twosome').find('.aplicable-content').find('.field__input').attr('required', true);
   $('.accordion__twosome').find('.aplicable-content').find('.field__label span').attr('aria-hidden', true);

   
   $('.twosome-text').show();
   $('.foursome-text').hide();
  }




});